import axios from 'axios';
import type { SiteId } from '@hotjar/site';
import { keysToCamelCase } from '@hotjar/webapp/lib/convert-string';
import { mapDtoToModel } from './mapper';
import type { FeaturedInsightsContent, Thumbnail, ThumbnailDto } from './types';

function getEndpointPath(siteId?: SiteId): string {
  return `/api/v1/activation/sites/${siteId}/start-page/insights`;
}

export async function getFeaturedInsightsContent(siteId: SiteId): Promise<FeaturedInsightsContent> {
  const response = await axios.get(getEndpointPath(siteId));

  return mapDtoToModel(response.data, true);
}

export async function getFeaturedInsightThumbnails(endpointPath = ''): Promise<Thumbnail> {
  const response: { data: ThumbnailDto } = await axios.get(endpointPath);

  return keysToCamelCase(response.data, true);
}
